module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    staticClass: "ql-position-cue-marker",
    style: ({
      backgroundColor: _vm.cueColor(_vm.cue)
    }),
    attrs: {
      "handles": [],
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cue.width || 20,
      "h": _vm.cue.height || 20,
      "minw": 10,
      "minh": 10,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  }, [(!_vm.locked && _vm.editable) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Move")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0be00e3b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/cue-position-marker.vue
// module id = 635
// module chunks = 2